"use strict";
window.theme = window.theme || {}
theme.cartAddItem = function() {

            function cartAddItem() {

                this.add_to_cart = {
                    btn_product_page: document.querySelector('.add-to-cart__button'),
                    btn_mobile_engraving: document.querySelectorAll('.engraving-add-to-cart__button'),
                    btn_sticky: document.querySelectorAll('.add-to-cart__button-header'),
                    btn_slider: document.querySelectorAll('.featured-collection-add-to-cart'),
                    btn_collection: document.querySelectorAll('.collection-add-to-cart'),
                    btn_homepage_desktop_slider: document.querySelectorAll('.product__cta-desktop-cart'),
                    btn_homepage_mobile_slider: document.querySelectorAll('.product__cta-mobile-cart'),
                    btn_custom: document.querySelectorAll('.js-add-to-cart')
                }

                this.mini_cart = {
                    container: document.querySelector('.quick-cart'),
                    quick_cart: document.querySelector('.page #shopify-section-header .header .header__inner .quick-cart'),
                    section_header: document.getElementById('shopify-section-header'),
                    quick_cart_content: document.querySelector('.quick-cart__container.popover'),
                    quick_cart_overlay_close: document.querySelectorAll('.quick-cart__overlay'),
                    header_quick_cart_close: document.querySelectorAll('[data-close-icon]'),
                    quick_cart_close: document.querySelectorAll('.quick-cart .quick-cart__close'),
                    quick_item_minus: document.querySelectorAll('.quick-cart .cart__item-button--minus'),
                    quick_item_plus: document.querySelectorAll('.quick-cart .cart__item-button--plus'),
                    quick_item_remove: document.querySelectorAll('.quick-cart .cart-item__remove'),
                    quick_item_engrave_remove: document.querySelectorAll('.cart-engrave-item__remove')
                }

                this.header_cart = {
                    quick_cart_open: document.querySelectorAll('[data-js-cart-icon]'),
                    bubble: document.querySelectorAll('button[data-js-cart-icon]')
                }
                this.limited_stock = {
                    container: document.querySelector('.product-limited-edition-sticker'),
                    btn_collection: document.querySelectorAll('.collection-add-to-cart'),
                    product_sticker: document.querySelectorAll('.product-limited-edition-sticker')
                }
                this.engraving = {
                    forms: document.querySelectorAll('.engraving-modal__form'),
                    openButtons: document.querySelectorAll('button.product-engraving__button'),
                    engrave_expandable: document.querySelectorAll('button.cart-engraving-properties')
                }

                this.load();

            }

            cartAddItem.prototype.load = function() {
                var _ = this; 
                if(_.add_to_cart.btn_custom) {
                    _.add_to_cart.btn_custom.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    })
                }
                if(_.add_to_cart.btn_product_page) {
                    if (_.engraving.forms.length > 0) {
                        _.add_to_cart.btn_product_page.addEventListener('click', (event) => {
                            // Check if any engraving form has been saved
                            var hasSavedEngraving = false;
                            _.engraving.forms.forEach(function(form) {
                                var savedInput = form.querySelector('.engraving-saved-input');
                                var termsCheckbox = form.querySelector('[name="engraving[terms_sales]"]');
                                if (savedInput && savedInput.value === "true") hasSavedEngraving = true;
                                if (termsCheckbox && termsCheckbox.checked) hasSavedEngraving = true;
                            });
                            if (hasSavedEngraving) {
                                _.engravingaddtocart(event);
                            } else {
                                _.addtocart(event);
                            }
                        });
                    } else {
                        _.add_to_cart.btn_product_page.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    }
                }
                if(_.add_to_cart.btn_sticky && _.add_to_cart.btn_sticky.length>0) {
                    _.add_to_cart.btn_sticky.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    })
                }
                if(_.mini_cart.quick_cart_overlay_close && _.mini_cart.quick_cart_overlay_close.length>0) {
                    _.mini_cart.quick_cart_overlay_close.forEach(e => {
                        e.addEventListener('click', () => {
                            _.minicartclose();
                        });
                    }) 
                }
                if(_.mini_cart.header_quick_cart_close && _.mini_cart.header_quick_cart_close.length>0) {
                    _.mini_cart.header_quick_cart_close.forEach(e => {
                        e.addEventListener('click', () => {
                            _.minicartclose();
                        });
                    }) 
                }
                if(_.header_cart.quick_cart_open && _.header_cart.quick_cart_open.length>0) {
                    _.header_cart.quick_cart_open.forEach(e => {
                        e.addEventListener('click', () => {
                            _.minicartopen();
                        })
                    })
                }
                if(_.add_to_cart.btn_slider && _.add_to_cart.btn_slider.length>0) {
                    _.add_to_cart.btn_slider.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        })  
                    })
                }
                if(_.add_to_cart.btn_collection && _.add_to_cart.btn_collection.length>0) {
                    _.add_to_cart.btn_collection.forEach(e => {
                        if(e.getAttribute('data-product-limited-edition') === 'false') {
                            e.addEventListener('click', (event) => {
                                _.addtocart(event);
                            })  
                        } else {
                            e.addEventListener('click', (event) => {
                                window.location.href = '/products/'+event.target.getAttribute('data-product-limited-handle');
                            })
                        }
                    })
                }
                if(_.add_to_cart.btn_homepage_desktop_slider && _.add_to_cart.btn_homepage_desktop_slider.length>0) {
                    _.add_to_cart.btn_homepage_desktop_slider.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    }) 
                }
                if(_.add_to_cart.btn_homepage_mobile_slider && _.add_to_cart.btn_homepage_mobile_slider.length>0) {
                    _.add_to_cart.btn_homepage_mobile_slider.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    }) 
                }
                if(_.engraving.engrave_expandable && _.engraving.engrave_expandable.length>0) {
                    _.engraving.engrave_expandable.forEach(e => {
                        e.addEventListener('click', (event) => {
                            event.target.nextElementSibling.classList.toggle('open');
                        });
                    })
                }
                if(_.header_cart.quick_cart_open && _.header_cart.quick_cart_open.length>0) {
                    _.header_cart.quick_cart_open.forEach(e => {
                        e.addEventListener('click', () => {
                            _.minicartopen();
                        })
                    })
                }
                if(_.add_to_cart.btn_homepage_desktop_slider && _.add_to_cart.btn_homepage_desktop_slider.length>0) {
                    _.add_to_cart.btn_homepage_desktop_slider.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    })
                }
                if(_.add_to_cart.btn_homepage_mobile_slider && _.add_to_cart.btn_homepage_mobile_slider.length>0) {
                    _.add_to_cart.btn_homepage_mobile_slider.forEach(e => {
                        e.addEventListener('click', (event) => {
                            _.addtocart(event);
                        });
                    })
                }
                if(_.add_to_cart.btn_mobile_engraving.length) {
                    _.add_to_cart.btn_mobile_engraving.forEach(el => {
                        el.addEventListener('click', (event) => {
                            var hasSavedEngraving = false;
                            _.engraving.forms.forEach(function(form) {
                                var savedInput = form.querySelector('.engraving-saved-input');
                                var termsCheckbox = form.querySelector('[name="engraving[terms_sales]"]');
                                if (savedInput && savedInput.value === "true") hasSavedEngraving = true;
                                if (termsCheckbox && termsCheckbox.checked) hasSavedEngraving = true;
                            });
                            if (hasSavedEngraving) {
                                _.engravingaddtocart(event);
                            } else {
                                _.addtocart(event);
                            }
                        });
                     })
                }
                if(_.limited_stock.product_sticker && _.limited_stock.product_sticker.length > 0) {
                    _.checkcartitem();
                }
            }

            cartAddItem.prototype.minicartopen = function() {
                var _ = this;
                let scrollPosition = window.pageYOffset;
                _.mini_cart.quick_cart.classList.add('active');
                setTimeout(() => {
                _.mini_cart.quick_cart.classList.add('visible');
                }, 300);
                document.body.style.setProperty('overflow', 'hidden');   
                document.body.style.setProperty('position', 'fixed');  
                document.body.style.setProperty('top', `-${scrollPosition}px`);  
                document.body.style.setProperty('width', '100%');  
                _.checkcartitem();
            }

            cartAddItem.prototype.minicartclose = function() {
                var _ = this;
                if(window.location.pathname.includes('cart')) {
                    location.reload();
                } else {
                document.body.removeAttribute('style');
                _.mini_cart.quick_cart.classList.remove('active');
                setTimeout(() => {
                _.mini_cart.quick_cart.classList.remove('visible');
                }, 300);
                }
            }

            cartAddItem.prototype.checkcartitem = function() {
                var _ = this;
                fetch('/cart.js')
                .then(response => response.json())
                .then(data => { 
                    if(data.item_count>0) {
                        if(window.location.pathname.includes('product') && _.limited_stock.container) {
                            let product_id = Number(_.limited_stock.container.getAttribute('data-product-id'));
                            let qty_limit = Number(_.limited_stock.container.getAttribute('data-qty-limit'));
                                data.items.forEach(item => {
                                if(item.id == product_id && Number(item.quantity) >= qty_limit) {                        
                                    _.add_to_cart.btn_product_page.setAttribute('disabled', '');
                                    _.add_to_cart.btn_sticky.forEach(e => {
                                        e.setAttribute('disabled', '');
                                    })
                                }
                            }); 
                        }                    
                        _.updatequickcart();                  
                    } else {                        
                        _.updatequickcart();
                        if(window.location.pathname.includes('product') && _.limited_stock.container) {
                        if(_.add_to_cart.btn_product_page)_.add_to_cart.btn_product_page.removeAttribute('disabled');
                        _.add_to_cart.btn_sticky.forEach(e => {
                        e.removeAttribute('disabled');                     
                        })
                        }
                    }
                })

                .catch((error) => {
                    console.error('Error:', error);
                });
            }

            cartAddItem.prototype.addtocart = function(event) {
                var _ = this;
                let product_availability = event.target.closest('button').getAttribute('data-product-availability') === 'true' ? true : false;
                if(!window.location.pathname.includes('product') && !product_availability) {
                    return false;
                }        
                let product_id = Number(event.target.closest('button').getAttribute('data-product-variant-id'));
                let collections = null;

                if(window.location.href.includes("/collections")){
                    collections = event.target.closest('.collection-product-item-cta').getAttribute('data-product-collections').split(',');
                }
                else{
                    collections = event.target.closest('button').getAttribute('data-product-collections').split(',');
                }
                let formData = {
                    'items': [{
                    'id': product_id,
                    'quantity': 1
                    }]
                };        

                fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
                })        
                .then(response => {
                    return response.json();
                })        
                .then(data => { 
                    if(data.status == 422) {
                        return false;
                    }
                    if(data.items.length>0) {
                        let items_arr = [];
                        let item_obj = {};
                        let quantity = 1;
                        let sku = data.items[0].sku ;
                        let variant = data.items[0].variant_options[0];
                        let brand = data.items[0].vendor;
                        let product_name = data.items[0].product_title;
                        let categories = collections;
                        let product_price = data.items[0].final_price / 100;
                        let page_type = "";

                        item_obj.item_name = product_name;
                        item_obj.item_id = sku;
                        item_obj.price = product_price;
                        item_obj.item_brand = brand;
                        categories.map( (category, index) => {
                            let catNum = index + 1;
                            item_obj["item_category" + catNum ] = category;  
                          });
                        item_obj.item_variant = variant;
                        item_obj.quantity = quantity;

                        items_arr.push(item_obj);
                        if(window.location.href.includes("products")){
                            page_type = "product page";
                        }
                        else if (window.location.href.includes("collections")){
                            page_type = "collection page";
                        }
                        else{
                            page_type = "home page";
                        }
                        dataLayer.push({
                            event: "add_to_cart",
                            add_to_cart_type: page_type,
                            ecommerce: {
                                items: items_arr
                            }
                        });
                        _.minicartopen();
                        document.querySelectorAll('.engraving-modal__close').forEach(function(closeBtn) {
                            closeBtn.click();
                        });
                    }       
                })        
                .catch((error) => {
                console.error('Error:', error);
                });
            }

            cartAddItem.prototype.updatequickcart = function() {
                var _ = this;
                fetch('/?sections=quick-cart', {
                    method: 'GET',
                    headers: {
                    'Accept': `application/json`,
                    'Content-Type': 'application/json'
                    }
                })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    let cart_item_content = new DOMParser()
                    .parseFromString(data["quick-cart"], 'text/html')
                    .querySelector('.quick-cart__container').innerHTML;
                    _.mini_cart.quick_cart_content.innerHTML = cart_item_content;
                    let quick_cart_close = document.querySelectorAll('.quick-cart .quick-cart__close');
                    let quick_item_minus = document.querySelectorAll('.quick-cart .cart__item-button--minus');
                    let quick_item_plus = document.querySelectorAll('.quick-cart .cart__item-button--plus');
                    let quick_item_remove = document.querySelectorAll('.quick-cart .cart-item__remove');
                    let quick_item_engrave_remove = document.querySelectorAll('.quick-cart .cart-engrave-item__remove');
                    let quick_item_engrave_edit = document.querySelectorAll('.quick-cart .cart-engrave-item__edit');
                    let quick_item_engrave_entire_remove = document.querySelectorAll('.quick-cart .cart__item-button-with-engrave');
                    let quick_item_engrave_add = document.querySelectorAll('.quick-cart .cart-engrave-item__add');
                    let quick_cart_items = document.querySelectorAll('.quick-cart .quick-cart__items .quick-cart__item');
                    let quick_cart_subtotal = document.querySelector('.quick-cart .quick-cart__total .fs-body-bold').textContent.replace(",", "").replace("£", "");

                    var prods = [];
                    
                    if(quick_cart_items.length) {
                    quick_cart_items.forEach(el => {

                        let item_title = el.getAttribute("data-title");
                        let item_id = el.getAttribute("data-id");
                        let item_variant = el.getAttribute("data-variant");
                        let item_brand = el.getAttribute("data-brand");
                        let item_collections = el.getAttribute("data-collections").split(',');
                        let item_price = el.getAttribute("data-price");
                        let item_quanity = el.getAttribute("data-quantity");

                        var prod = {};

                        prod.item_name = item_title;
                        prod.item_id = item_id;
                        prod.price = item_price/100;
                        prod.item_brand = item_brand;
                        prod.item_variant = item_variant;
                        item_collections.map( (category, index) => {
                            let catNum = index + 1;
                            prod["item_category" + catNum ] = category;  
                          });
                        prod.quantity = +item_quanity;

    
                        prods.push(prod);
                        
                    });
                    }

                    if (prods.length > 0) {
                            dataLayer.push({
                                event: "view_cart",
                                items: prods
                            });                        
                      }


                    if(quick_cart_close.length>0) {
                        quick_cart_close.forEach(el => {
                            el.addEventListener('click', () => {
                                _.minicartclose();
                            });
                        }) 
                    }     
                    if(quick_item_minus.length>0) {
                        quick_item_minus.forEach(el => {
                            el.addEventListener('click', () => {
                            let input_qty = el.nextElementSibling;
                            let current_qty = Number(input_qty.value);
                            if(current_qty>1) {
                                input_qty.value = current_qty-1;
                                var new_input_qty = Number(input_qty.value);
                                var max_qty = Number(input_qty.getAttribute('max'));
                                _.itemqtyupdate(input_qty.getAttribute('data-product-item-key'),Number(input_qty.value));
                                _.plusbtnupdate(new_input_qty, max_qty, el.nextElementSibling.nextElementSibling);
                            }
                            })
                        })
                    }
                    if(quick_item_plus.length>0) {
                        quick_item_plus.forEach(el => {
                            el.addEventListener('click', () => {
                            var input_qty = el.previousElementSibling;
                            var current_qty = Number(input_qty.value);
                            var max_qty = Number(input_qty.getAttribute('max'));
                            if(current_qty>0 && current_qty < max_qty) {
                                input_qty.value = current_qty+1;
                                var new_input_qty = Number(input_qty.value);
                                _.itemqtyupdate(input_qty.getAttribute('data-product-item-key'),Number(input_qty.value));
                                _.plusbtnupdate(new_input_qty, max_qty, el);
                            } else {
                            el.parentElement.parentElement.parentElement.parentElement.parentElement.children[1].innerHTML = "Can add at most " + max_qty;
                            }
                            })
                        })
                    }
                    if(quick_item_remove.length>0) {
                            quick_item_remove.forEach((el) => {
                                el.addEventListener('click', () => {
                            let input_qty = el.previousElementSibling.querySelector('.cart__item-qty-selector > input');
                            let item_title =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-title");
                            let item_price =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-price");
                            let item_sku  =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-id");
                            let item_brand  =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-brand");
                            let item_variant  =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-variant");
                            let item_collections  =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-collections").split(',');
                            let item_page  =  el.parentElement.parentElement.parentElement.parentElement.getAttribute("data-page");

                            let current_qty = Number(input_qty.value);
                            if(current_qty>0) {
                                input_qty.value = 0;                             
                                _.itemqtyupdate(input_qty.getAttribute('data-product-item-key'),Number(input_qty.value));
                            }
                            if(el.parentElement.parentElement.parentElement.parentElement) {
                                el.parentElement.parentElement.parentElement.parentElement.remove();   

                                let data_arr = [];
                                let data_obj = {};

                                let quantity = current_qty;
                                let sku = item_sku;
                                let variant = item_variant;
                                let brand = item_brand;
                                let product_name = item_title;
                                let categories = item_collections;
                                let product_price = item_price / 100;
        
                                data_obj.item_name = product_name;
                                data_obj.item_id = sku;
                                data_obj.price = product_price;
                                data_obj.item_brand = brand;
                                categories.map( (category, index) => {
                                    let catNum = index + 1;
                                    data_obj["item_category" + catNum ] = category;  
                                  });
                                data_obj.item_variant = variant;
                                data_obj.quantity = quantity;
        
                                data_arr.push(data_obj);
        
                                dataLayer.push({
                                  event: 'remove_from_cart',
                                  add_to_cart_type :'product page',
                                  ecommerce: {
                                    items: data_arr
                                  }
                                });
                                
                            }    
                            if(el.parentElement.parentElement.parentElement.parentElement.nextElementSibling) {
                                if(el.parentElement.parentElement.parentElement.parentElement.nextElementSibling.classList.contains('quick-cart-engrave__services')) {
                                    el.parentElement.parentElement.parentElement.parentElement.nextElementSibling.remove();
                                }
                            }                                              
                            })
                        })
                    }
                    if(quick_item_engrave_remove.length>0) {
                        quick_item_engrave_remove.forEach(el => {
                            el.addEventListener('click', event => {
                                _.engravingremoveproperties(event.target.closest('button').getAttribute('data-product-item-key'),event);
                            })
                        })            
                    }
                    if(quick_item_engrave_edit.length>0) {
                        quick_item_engrave_edit.forEach(el => {
                            el.addEventListener('click', event => {
                                let btn = event.target.closest('button');
                                let properties = {};
                                try { properties = JSON.parse(btn.getAttribute('data-engraving-properties') || '{}'); } catch(e) {}
                                let engavingjsontext = {
                                    'editengrave': {
                                        'key': btn.getAttribute('data-product-item-key'),
                                        'line': btn.getAttribute('data-line-item'),
                                        'handle': btn.getAttribute('data-product-handle'),
                                        'properties': properties
                                    }
                                }
                                _.setjsonproperty(JSON.stringify(engavingjsontext));
                                window.location.href = '/products/'+btn.getAttribute('data-product-handle');
                            })
                        })
                    }
                    if(quick_item_engrave_entire_remove.length>0) {
                        quick_item_engrave_entire_remove.forEach(el => {
                            el.addEventListener('click', event => {
                                _.engravingremoveentirely(event.target.closest('button').getAttribute('data-product-item-key'),event.target.closest('button').getAttribute('data-engrave-item-key'));
                            })
                        })            
                    }
                    if(quick_item_engrave_add.length>0) {
                        quick_item_engrave_add.forEach(el => {
                            el.addEventListener('click', event => {
                                let engavingjsontext = {
                                    'editengrave': {
                                        'key': event.target.closest('button').getAttribute('data-product-item-key'),
                                        'line': event.target.closest('button').getAttribute('data-line-item'),
                                        'handle': event.target.closest('button').getAttribute('data-product-handle'),
                                        'firstline': '',
                                        'secondline': '',
                                        'thirdline': '',
                                        'glasslines': ''
                                    }
                                }
                                _.setjsonproperty(JSON.stringify(engavingjsontext));
                                window.location.href = '/products/'+event.target.closest('button').getAttribute('data-product-handle'); 
                            })
                        })            
                    }
                    _.updatebubblecart();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }

            cartAddItem.prototype.updatebubblecart = function() {
                var _ = this;
                fetch('/?sections=bubble-cart', {
                    method: 'GET',
                    headers: {
                    'Accept': `application/json`,
                    'Content-Type': 'application/json'
                    }
                })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    let bubble_cart_content = new DOMParser()
                    .parseFromString(data["bubble-cart"], 'text/html')
                    .querySelector('.shopify-section').innerHTML;
                    _.header_cart.bubble.forEach(el => {
                        el.innerHTML = bubble_cart_content;
                    })
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
            cartAddItem.prototype.itemqtyupdate = function(product_key,qty) {
                var _ = this;
                let formData = {
                    updates : {
                    [product_key] : qty
                    }
                };     
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if(data.item_count == 0) {
                        _.quickcartupdatetotal();
                        if(_.add_to_cart.btn_product_page)_.add_to_cart.btn_product_page.removeAttribute('disabled');
                        _.engraving.forms.forEach(function(form) {
                            form.classList.remove('active');
                        });
                        _.engraving.openButtons.forEach(function(btn) {
                            btn.classList.remove('d-none');
                        });
                        _.minicartclose();
                    } else {
                        _.quickcartupdatetotal();
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
            cartAddItem.prototype.quickcartupdatetotal = function() {
                    var _ = this;
                fetch('/?sections=quick-cart-total')
                .then(response => {
                    return response.json();
                })
                .then((data) => {
                    let quick_cart_total = document.querySelector('.quick-cart .quick-cart__total');
                    let cart_total_content = new DOMParser()
                    .parseFromString(data["quick-cart-total"], 'text/html')
                    .querySelector('.quick-cart__total').innerHTML;
                    quick_cart_total.innerHTML = cart_total_content;
                    _.updatebubblecart();
                }) 
                .catch((error) => {
                    console.error('Error:', error);
                });       
            }
            cartAddItem.prototype.plusbtnupdate = function(current_qty, max_qty, plus_btn) {
                    if (current_qty < max_qty) {
                        plus_btn.disabled = false;
                    } else {
                        plus_btn.disabled = true;
                    }
            }
            cartAddItem.prototype.buildEngravingProperties = function(form) {
                var properties = {};
                var configSections = form.querySelectorAll('.engraving-config-section');

                configSections.forEach(function(section) {
    var configType = section.getAttribute('data-config-type');
    var inputs = section.querySelectorAll('input.engraving_line');
    var hasContent = Array.prototype.some.call(inputs, function(inp) { return inp.value.trim() !== ''; });
    inputs.forEach(function(input, index) {
        if (configType === 'bottle') {
            properties['Decanter-Engraving-Text-Line' + (index + 1)] = input.value;
        } else if (configType === 'glass') {
            properties['Glass' + (index + 1) + '-Engraving-Text'] = input.value;
        } else {
            var typeName = configType.split('-').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join('-');
            properties[typeName + '-Engraving-Text-Line' + (index + 1)] = input.value;
        }
    });
    // Always set gold engravings: use the input's value when present, otherwise 'No'
    var goldInput = section.querySelector('.gold-engraving-input');
    properties['Glass-Gold-Engravings'] = goldInput ? goldInput.value : 'No';

    // Add curved shape flag per type when the type has at least one non-empty line
     if (hasContent) {
                        var shape = (section.getAttribute('data-preview-shape') || '').toLowerCase();
                        var curvedTypeName;
                        if (configType === 'bottle') {
                            curvedTypeName = 'Decanter';
                        } else {
                            curvedTypeName = configType.split('-').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join('-');
                        }
                        properties['Curved-' + curvedTypeName + '-Engraving'] = shape === 'curved' ? 'Yes' : 'No';
                    }
});


                return properties;
            }
            cartAddItem.prototype.engravingaddtocart = function(event) {
                var _ = this;
                let product_id = event.target.closest('button').getAttribute('data-product-variant-id');
                let formData = {};

                // Find the active engraving form (one with saved input or checked terms)
                var activeForm = null;
                _.engraving.forms.forEach(function(form) {
                    var savedInput = form.querySelector('.engraving-saved-input');
                    var termsCheckbox = form.querySelector('[name="engraving[terms_sales]"]');
                    if ((savedInput && savedInput.value === "true") || (termsCheckbox && termsCheckbox.checked)) {
                        activeForm = form;
                    }
                });

                if (!activeForm) return;

                var properties = _.buildEngravingProperties(activeForm);

                formData = {
                    'items': [
                        {
                            'id': product_id,
                            'quantity': 1,
                            properties: properties
                        }
                    ]
                };
              
                fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
                })        
                .then(response => {
                    return response.json();
                })        
                .then(data => { 
                    if(data.status == 422) {
                        return false;
                    }
                    if(data.items.length>0) {
                        // Reset all engraving recap buttons
                        document.querySelectorAll('.engraving-recap-reset').forEach(function(resetBtn) {
                            resetBtn.click();
                        });
                        // Close all engraving modals
                        document.querySelectorAll('.engraving-modal__close').forEach(function(closeBtn) {
                            closeBtn.click();
                        });
                        _.minicartopen();
                    }       
                })        
                .catch((error) => {
                console.error('Error:', error);
                });
            }
            cartAddItem.prototype.engravingupdates = function(product_key,product_qty,engrave_key) {
                var _ = this;
                let formData = {
                    updates : {
                    [product_key] : 0
                    }
                };     
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                    })        
                    .then(response => {
                        return response.json();
                    })        
                    .then(data => { 
                        if(data.status == 422) {
                            return false;
                        }
                        if(data.items.length > 0) {
                            _.updatequickcart();
                        }  
                        if(data.item_count == 0) {
                            _.updatequickcart();
                            _.minicartclose();
                        }     
                    })        
                    .catch((error) => {
                    console.error('Error:', error);
                    });
            }
            cartAddItem.prototype.engravingpropertyupdate = function(item_key,firstline,secondline, thirdline, glasslines = []) {
                var _ = this;
                let formData = {};

                // Find the active form to build properties
                var activeForm = null;
                _.engraving.forms.forEach(function(form) {
                    if (form.getAttribute('data-item-key') === item_key) {
                        activeForm = form;
                    }
                });

                if (activeForm) {
                    var properties = _.buildEngravingProperties(activeForm);
                    formData = {
                        'line': item_key,
                        'properties': properties
                    };
                } else {
                    // Fallback: build properties from parameters
                    var properties = {};
                    if (firstline) properties['Decanter-Engraving-Text-Line1'] = firstline;
                    if (secondline) properties['Decanter-Engraving-Text-Line2'] = secondline;
                    if (thirdline && thirdline !== -1) properties['Decanter-Engraving-Text-Line3'] = thirdline;
                    glasslines.forEach(function(v, i) {
                        properties['Glass' + (i + 1) + '-Engraving-Text'] = v;
                    });
                    formData = {
                        'line': item_key,
                        'properties': properties
                    };
                }
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                    })        
                    .then(response => {
                        return response.json();
                    })        
                    .then(data => { 
                        if(data.status == 422) {
                            return false;
                        }
                        if(data.items.length > 0) {
                            document.querySelectorAll('.engraving-modal__close').forEach(function(closeBtn) {
                                closeBtn.click();
                            });
                            _.minicartopen();
                            _.setjsonproperty('close');
                        }  
                        if(data.item_count == 0) {
                            _.setjsonproperty('close');
                            _.minicartclose();
                        }     
                    })        
                    .catch((error) => {
                    console.error('Error:', error);
                    location.reload();
                    });
            }
            cartAddItem.prototype.engravingremoveproperties = function(product_key,event) {
                var _ = this;
                let engraving_fee = event.target.closest('button').getAttribute('data-engrave-item-key') !== '' ? true : false;               
                let formData = {};
                if(engraving_fee) {
                    let engrave_key = event.target.closest('button').getAttribute('data-engrave-item-key'); 
                    formData = {
                        updates : {
                        [product_key] : 0,
                        [engrave_key] : 0
                        }
                    };     
                } else {
                    formData = {
                        updates : {
                        [product_key] : 0
                        }
                    };     
                }               
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                    })        
                    .then(response => {
                        return response.json();
                    })        
                    .then(data => { 
                        if(data.status == 422) {
                            return false;
                        }
                        if(data.items.length > 0) {
                            _.setjsonproperty('close');
                            _.addtocart(event);
                            return false;
                        }  
                        if(data.item_count == 0) {
                            _.setjsonproperty('close');
                            _.addtocart(event);
                            return false;
                        }     
                    })        
                    .catch((error) => {
                    console.error('Error:', error);
                    });
            }
            cartAddItem.prototype.engravingremoveentirely = function(product_key,engrave_key) {
                var _ = this;
                let formData = {};
                if(engrave_key !== '') {
                    formData = {
                        updates : {
                        [product_key] : 0,
                        [engrave_key] : 0
                        }
                    };  
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                        })        
                        .then(response => {
                            return response.json();
                        })        
                        .then(data => { 
                            if(data.status == 422) {
                                return false;
                            }
                            if(data.item_count > 0) {                               
                                _.setjsonproperty('close');
                                _.checkcartitem();
                                return false;
                            }  
                            if(data.item_count == 0) {
                                _.setjsonproperty('close');
                                _.checkcartitem();
                                _.minicartclose();
                                _.close
                                return false;
                            }     
                        })        
                        .catch((error) => {
                        console.error('Error:', error);
                        });                      
                } else {
                    formData = {
                        updates : {
                        [product_key] : 0                        }
                    };  
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                        })        
                        .then(response => {
                            return response.json();
                        })        
                        .then(data => { 
                            if(data.status == 422) {
                                return false;
                            }
                            if(data.item_count > 0) {                               
                                _.setjsonproperty('close');
                                _.checkcartitem();
                                return false;
                            }  
                            if(data.item_count == 0) {
                                _.setjsonproperty('close');
                                _.checkcartitem();
                                _.minicartclose();
                                _.close
                                return false;
                            }     
                        })        
                        .catch((error) => {
                        console.error('Error:', error);
                        });          
                }

            }
            cartAddItem.prototype.setjsonproperty = function(cvalue) {
                const d = new Date();
                d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
                let expires = "expires="+d.toUTCString();
                document.cookie = 'customengravingjson' + "=" + cvalue + ";" + expires + ";path=/";
            }
            cartAddItem.prototype.getjsonproperty = function(cname) {
                let name = cname + "=";
                let ca = document.cookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                  let c = ca[i];
                  while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                  }
                  if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                  }
                }
                return "close";
            }

     theme.cartAddItem = new cartAddItem;

}

theme.cartAddItem();